// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");

document.querySelector(".seemore").addEventListener("click", function() {
  document.querySelector(".container").classList.toggle("truncated");
  document.querySelector(".seemore").classList.toggle("truncated");
})